import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface PasswordInputProps {
    label?: string;
    validationEnabled?: boolean;
    onValidate?: (isValid: boolean) => void;
}

export default function PasswordInput({
    label,
    validationEnabled = false,
    onValidate,
}: PasswordInputProps) {
    const [password, setPassword] = useState<string>("");
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [isValid, setIsValid] = useState<boolean | null>(null);
    const { t } = useTranslation();

    const validatePassword = (value: string) => {
        const conditions = [
            value.length >= 8,
            /[A-Z]/.test(value),
            /[a-z]/.test(value),
            /\d/.test(value),
        ];
        const result = conditions.every((condition) => condition);
        setIsValid(result);
        onValidate?.(result);
    };

    useEffect(() => {
        if (password.length === 0) {
            setIsValid(null);
        } else {
            validatePassword(password);
        }
    }, [password]);

    return (
        <>
            <TextField
                required
                fullWidth
                name="password"
                label={label ? label : t("auth.password")}
                type={showPassword ? "text" : "password"}
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => {
                    setPassword(e.target.value);
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => setShowPassword(!showPassword)}
                                edge="end"
                            >
                                {showPassword ? (
                                    <Visibility />
                                ) : (
                                    <VisibilityOff />
                                )}
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
            {!isValid && password.length > 0 && (
                <div
                    style={{
                        fontSize: "12px",
                        marginTop: "4px",
                        color: "#CC0000",
                    }}
                >
                    {t("error.password.requirements")}
                </div>
            )}
        </>
    );
}
